module.exports = __webpack_public_path__ + "img/esusfeedback.de13c0bb.png";